// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ajax-file-upload{
    float:right;
    margin: 0 0 0 0;
}
.ajax-upload-dragdrop{
    min-height:30px;
    border: 1px solid #A5A5C7;
    width: 100%;
    text-align: left;
    vertical-align: middle;
    padding: 0;
}
.ajax-upload-dragdrop span{
    padding:8px 4px;
    display:inline-block;
}
.ajax-file-upload-container {
    margin: 10px 0px 0 0;
}

._url {
    margin: 10px 0px 0 0;
}

.urlbutton, .urlbutton:hover {
    font-family: 'News Cycle', sans-serif;
    /* font-size: 16px; */
    /* font-weight: bold; */
    cursor: pointer;
    /* line-height: 20px; */
    height: 38px;
    margin: 0;
    display: inline-block;
    background: #fff;
    border: 0;
    text-align: center;
    color: #888;
    min-width: 36px;
    text-decoration: none;
    border-radius: 0;
    -webkit-border-radius: 0;
    -moz-border-radius: 0;
    -moz-box-shadow: none;
    -webkit-box-shadow: none;
    box-shadow: none;
    /* padding: 4px; */
    color: #fff;
    background: #2f8ab9;
    border: none;
}

.required .ajax-upload-dragdrop {
background: #EEEEEE;
color:#000;
font-weight:normal;
}

.required.urlcont,
.required.urlcont input {

background: #EEEEEE;
color: #000;
}
.item_name {
display: none;
width: 100%;
min-height:30px;
border: 1px solid #A5A5C7;
}
.item_name span{
display:inline-block;
padding:10px;
}

.ajax-file-upload {
    font-family: 'News Cycle', sans-serif;
    /* font-size: 16px; */
    /* font-weight: bold; */
    cursor: pointer !important;
    //line-height: 20px;
    height: 40px;
    width: 37px;
    cursor: pointer;
    position: absolute;
    /* vertical-align: top; */
    margin: 0;
    display: inline-block;
    background: #fff;
    border: 0;
    color: #888;
    font-size: 0;
    /* min-width: 36px; */
    text-decoration: none;
    border-radius: 0;
    -webkit-border-radius: 0;
    -moz-border-radius: 0;
    -moz-box-shadow: none;
    -webkit-box-shadow: none;
    box-shadow: none;
    padding: 4px;
    color: #fff;
    background: #2f8ab9;
    border: none;
    .bi, input{
        cursor: pointer!important;
    }
}
input[type=file],
input[type=file]::file-selector-button {
    cursor: pointer;
}
.ajax-file-upload:hover {
background: #3396c9;
-moz-box-shadow: none;
-webkit-box-shadow: none;
opacity:.5;
box-shadow: none;
}
.ajax-upload-dragdrop,.ajax-file-upload-statusbar{
width:100%!important;
margin:5px 0;
}
.ajax-upload-dragdrop.state-hover{
opacity:0.5;
}
.ajax-file-upload-filename{
width:calc(100% - 10px)!important;
word-break: break-all;
}
.item_name.required, .item_name.required a {
background: #d4edda;
color: #155724;
}
.ajax-file-upload-progress {
margin: 5px 10px 5px 0px;
width:90%;

}
.item-upload-container h3{
font-size:15px;
}
.item-upload-container h3 span{
color:#d50d27;
}
.item_name.vis {
display: block;
}
.item_name.required, .item_name.required a {
background: #d4edda;
color: #155724;
}
.noresult {
display: none;
}
.urlcont {
margin: 10px 0px 0 0;
width: 100%;
border: 1px solid #A5A5C7;
}

.item-upload-container {
display: inline-block;
width: 33%;
vertical-align: top;
margin-bottom:1rem;
input {
    width: calc(100% - 41px);
    font-size: 16px;
    padding: 6px 0 6px 7px;
    border: none;
}
    a{
        font-size:14px;
        text-decoration: none;
        color:#337ab7;
    }
}
.media-list{
     .content{

        border:1px solid #ddd;
    }
    a{
        font-size:14px;
        text-decoration: none;
        color:#337ab7;
    }
     span {
        display: inline-block;
        padding: 10px;
    }
}
@media screen and (max-width: 768px) {
.item-upload-container {
display: block;
width: 100%;
vertical-align: top;
}

.ajax-upload-dragdrop {
width: 100% !important;
}

.urlcont {
width: 100% !important;
}}`, "",{"version":3,"sources":["webpack://./src/scss/uploadfile.custom.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,eAAe;AACnB;AACA;IACI,eAAe;IACf,yBAAyB;IACzB,WAAW;IACX,gBAAgB;IAChB,sBAAsB;IACtB,UAAU;AACd;AACA;IACI,eAAe;IACf,oBAAoB;AACxB;AACA;IACI,oBAAoB;AACxB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,qCAAqC;IACrC,qBAAqB;IACrB,uBAAuB;IACvB,eAAe;IACf,uBAAuB;IACvB,YAAY;IACZ,SAAS;IACT,qBAAqB;IACrB,gBAAgB;IAChB,SAAS;IACT,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,qBAAqB;IACrB,gBAAgB;IAChB,wBAAwB;IACxB,qBAAqB;IACrB,qBAAqB;IACrB,wBAAwB;IACxB,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;IACX,mBAAmB;IACnB,YAAY;AAChB;;AAEA;AACA,mBAAmB;AACnB,UAAU;AACV,kBAAkB;AAClB;;AAEA;;;AAGA,mBAAmB;AACnB,WAAW;AACX;AACA;AACA,aAAa;AACb,WAAW;AACX,eAAe;AACf,yBAAyB;AACzB;AACA;AACA,oBAAoB;AACpB,YAAY;AACZ;;AAEA;IACI,qCAAqC;IACrC,qBAAqB;IACrB,uBAAuB;IACvB,0BAA0B;IAC1B,mBAAmB;IACnB,YAAY;IACZ,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,yBAAyB;IACzB,SAAS;IACT,qBAAqB;IACrB,gBAAgB;IAChB,SAAS;IACT,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB,qBAAqB;IACrB,gBAAgB;IAChB,wBAAwB;IACxB,qBAAqB;IACrB,qBAAqB;IACrB,wBAAwB;IACxB,gBAAgB;IAChB,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,YAAY;IACZ;QACI,yBAAyB;IAC7B;AACJ;AACA;;IAEI,eAAe;AACnB;AACA;AACA,mBAAmB;AACnB,qBAAqB;AACrB,wBAAwB;AACxB,UAAU;AACV,gBAAgB;AAChB;AACA;AACA,oBAAoB;AACpB,YAAY;AACZ;AACA;AACA,WAAW;AACX;AACA;AACA,iCAAiC;AACjC,qBAAqB;AACrB;AACA;AACA,mBAAmB;AACnB,cAAc;AACd;AACA;AACA,wBAAwB;AACxB,SAAS;;AAET;AACA;AACA,cAAc;AACd;AACA;AACA,aAAa;AACb;AACA;AACA,cAAc;AACd;AACA;AACA,mBAAmB;AACnB,cAAc;AACd;AACA;AACA,aAAa;AACb;AACA;AACA,oBAAoB;AACpB,WAAW;AACX,yBAAyB;AACzB;;AAEA;AACA,qBAAqB;AACrB,UAAU;AACV,mBAAmB;AACnB,kBAAkB;AAClB;IACI,wBAAwB;IACxB,eAAe;IACf,sBAAsB;IACtB,YAAY;AAChB;IACI;QACI,cAAc;QACd,qBAAqB;QACrB,aAAa;IACjB;AACJ;AACA;KACK;;QAEG,qBAAqB;IACzB;IACA;QACI,cAAc;QACd,qBAAqB;QACrB,aAAa;IACjB;KACC;QACG,qBAAqB;QACrB,aAAa;IACjB;AACJ;AACA;AACA;AACA,cAAc;AACd,WAAW;AACX,mBAAmB;AACnB;;AAEA;AACA,sBAAsB;AACtB;;AAEA;AACA,sBAAsB;AACtB,CAAC","sourcesContent":[".ajax-file-upload{\r\n    float:right;\r\n    margin: 0 0 0 0;\r\n}\r\n.ajax-upload-dragdrop{\r\n    min-height:30px;\r\n    border: 1px solid #A5A5C7;\r\n    width: 100%;\r\n    text-align: left;\r\n    vertical-align: middle;\r\n    padding: 0;\r\n}\r\n.ajax-upload-dragdrop span{\r\n    padding:8px 4px;\r\n    display:inline-block;\r\n}\r\n.ajax-file-upload-container {\r\n    margin: 10px 0px 0 0;\r\n}\r\n\r\n._url {\r\n    margin: 10px 0px 0 0;\r\n}\r\n\r\n.urlbutton, .urlbutton:hover {\r\n    font-family: 'News Cycle', sans-serif;\r\n    /* font-size: 16px; */\r\n    /* font-weight: bold; */\r\n    cursor: pointer;\r\n    /* line-height: 20px; */\r\n    height: 38px;\r\n    margin: 0;\r\n    display: inline-block;\r\n    background: #fff;\r\n    border: 0;\r\n    text-align: center;\r\n    color: #888;\r\n    min-width: 36px;\r\n    text-decoration: none;\r\n    border-radius: 0;\r\n    -webkit-border-radius: 0;\r\n    -moz-border-radius: 0;\r\n    -moz-box-shadow: none;\r\n    -webkit-box-shadow: none;\r\n    box-shadow: none;\r\n    /* padding: 4px; */\r\n    color: #fff;\r\n    background: #2f8ab9;\r\n    border: none;\r\n}\r\n\r\n.required .ajax-upload-dragdrop {\r\nbackground: #EEEEEE;\r\ncolor:#000;\r\nfont-weight:normal;\r\n}\r\n\r\n.required.urlcont,\r\n.required.urlcont input {\r\n\r\nbackground: #EEEEEE;\r\ncolor: #000;\r\n}\r\n.item_name {\r\ndisplay: none;\r\nwidth: 100%;\r\nmin-height:30px;\r\nborder: 1px solid #A5A5C7;\r\n}\r\n.item_name span{\r\ndisplay:inline-block;\r\npadding:10px;\r\n}\r\n\r\n.ajax-file-upload {\r\n    font-family: 'News Cycle', sans-serif;\r\n    /* font-size: 16px; */\r\n    /* font-weight: bold; */\r\n    cursor: pointer !important;\r\n    //line-height: 20px;\r\n    height: 40px;\r\n    width: 37px;\r\n    cursor: pointer;\r\n    position: absolute;\r\n    /* vertical-align: top; */\r\n    margin: 0;\r\n    display: inline-block;\r\n    background: #fff;\r\n    border: 0;\r\n    color: #888;\r\n    font-size: 0;\r\n    /* min-width: 36px; */\r\n    text-decoration: none;\r\n    border-radius: 0;\r\n    -webkit-border-radius: 0;\r\n    -moz-border-radius: 0;\r\n    -moz-box-shadow: none;\r\n    -webkit-box-shadow: none;\r\n    box-shadow: none;\r\n    padding: 4px;\r\n    color: #fff;\r\n    background: #2f8ab9;\r\n    border: none;\r\n    .bi, input{\r\n        cursor: pointer!important;\r\n    }\r\n}\r\ninput[type=file],\r\ninput[type=file]::file-selector-button {\r\n    cursor: pointer;\r\n}\r\n.ajax-file-upload:hover {\r\nbackground: #3396c9;\r\n-moz-box-shadow: none;\r\n-webkit-box-shadow: none;\r\nopacity:.5;\r\nbox-shadow: none;\r\n}\r\n.ajax-upload-dragdrop,.ajax-file-upload-statusbar{\r\nwidth:100%!important;\r\nmargin:5px 0;\r\n}\r\n.ajax-upload-dragdrop.state-hover{\r\nopacity:0.5;\r\n}\r\n.ajax-file-upload-filename{\r\nwidth:calc(100% - 10px)!important;\r\nword-break: break-all;\r\n}\r\n.item_name.required, .item_name.required a {\r\nbackground: #d4edda;\r\ncolor: #155724;\r\n}\r\n.ajax-file-upload-progress {\r\nmargin: 5px 10px 5px 0px;\r\nwidth:90%;\r\n\r\n}\r\n.item-upload-container h3{\r\nfont-size:15px;\r\n}\r\n.item-upload-container h3 span{\r\ncolor:#d50d27;\r\n}\r\n.item_name.vis {\r\ndisplay: block;\r\n}\r\n.item_name.required, .item_name.required a {\r\nbackground: #d4edda;\r\ncolor: #155724;\r\n}\r\n.noresult {\r\ndisplay: none;\r\n}\r\n.urlcont {\r\nmargin: 10px 0px 0 0;\r\nwidth: 100%;\r\nborder: 1px solid #A5A5C7;\r\n}\r\n\r\n.item-upload-container {\r\ndisplay: inline-block;\r\nwidth: 33%;\r\nvertical-align: top;\r\nmargin-bottom:1rem;\r\ninput {\r\n    width: calc(100% - 41px);\r\n    font-size: 16px;\r\n    padding: 6px 0 6px 7px;\r\n    border: none;\r\n}\r\n    a{\r\n        font-size:14px;\r\n        text-decoration: none;\r\n        color:#337ab7;\r\n    }\r\n}\r\n.media-list{\r\n     .content{\r\n\r\n        border:1px solid #ddd;\r\n    }\r\n    a{\r\n        font-size:14px;\r\n        text-decoration: none;\r\n        color:#337ab7;\r\n    }\r\n     span {\r\n        display: inline-block;\r\n        padding: 10px;\r\n    }\r\n}\r\n@media screen and (max-width: 768px) {\r\n.item-upload-container {\r\ndisplay: block;\r\nwidth: 100%;\r\nvertical-align: top;\r\n}\r\n\r\n.ajax-upload-dragdrop {\r\nwidth: 100% !important;\r\n}\r\n\r\n.urlcont {\r\nwidth: 100% !important;\r\n}}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
